// Nepodařilo se zjistit, kdo je přihlášený (server neodpovídá, 5xx, neplatná odpověď) — nelze
// ani pustit dál, ani poslat na přihlášení. Ukáže důvod a nabídne „Zkusit znovu“.
import type { Chyba } from '../api/klient';
import './ChybaOvereni.css';

interface Props {
  chyba: Chyba | null;
  overuji: boolean;
  zkusitZnovu: () => void;
}

export function ChybaOvereni({ chyba, overuji, zkusitZnovu }: Props) {
  return (
    <main className="chyba-overeni">
      <section
        className="karta chyba-overeni__karta"
        role="alert"
        aria-labelledby="chyba-overeni-nadpis"
      >
        <h1 id="chyba-overeni-nadpis" className="chyba-overeni__nadpis">
          Nepodařilo se ověřit přihlášení
        </h1>
        <p className="chyba-overeni__text">
          {chyba?.zprava ?? 'Server neodpověděl. Zkuste to znovu.'}
        </p>
        {chyba && <p className="pole__napoveda">Kód: {chyba.kod}</p>}
        <button
          type="button"
          className="tlacitko tlacitko--primarni tlacitko--velke"
          onClick={zkusitZnovu}
          disabled={overuji}
        >
          {overuji ? 'Ověřuji…' : 'Zkusit znovu'}
        </button>
      </section>
    </main>
  );
}
